var exports = {
  "Sr": "xf0b3b88a--01989b--advices",
  "on": "xf0b3b88a--01989b--advices-header",
  "AJ": "xf0b3b88a--01989b--advices-rating",
  "hF": "xf0b3b88a--01989b--rating-link",
  "v9": "xf0b3b88a--01989b--advice",
  "qr": "xf0b3b88a--01989b--footer",
  "Q8": "xf0b3b88a--01989b--footer-text",
  "GQ": "xf0b3b88a--01989b--advice-link",
  "uv": "xf0b3b88a--01989b--advice-answer",
  "n": "xf0b3b88a--01989b--advice-name",
  "vR": "xf0b3b88a--01989b--tabs",
  "Mf": "xf0b3b88a--01989b--tab",
  "nJ": "xf0b3b88a--01989b--tab-counter",
  "qw": "xf0b3b88a--01989b--tab--active",
  "b1": "xf0b3b88a--01989b--question",
};

module.exports = exports;
